import {
  createAsyncThunk,
  createSlice,
  PayloadAction,
} from '@reduxjs/toolkit';
import { RootState } from '../../app/store';
import { notifyApi } from '../administration/notify-api';
import { Notify } from '../model/notify';

export interface GeneralState {
  header: {
    title: string;
    subTitle: string;
  };
  project: {
    members: any[];
  };
  apps: {
    data: any[];
    status: 'idle' | 'loading' | 'ready';
  };
  notifications: {
    data: Notify[];
    status: 'idle' | 'loading' | 'ready';
  };
}

const initialState: GeneralState = {
  header: {
    title: '',
    subTitle: '',
  },
  project: {
    members: [],
  },
  apps: {
    data: [],
    status: 'idle',
  },
  notifications: {
    data: [],
    status: 'idle',
  },
};

export const getNotifications = createAsyncThunk(
  'general/notifications',
  async (arg, { getState }) => {
    const state = getState() as RootState;
    if (state.general.notifications.status !== 'loading') {
      const res = await notifyApi.getAllUnSeen();
      return res;
    }
  },
);

export const generalSlice = createSlice({
  name: 'general',
  initialState,
  reducers: {
    headerTitle: (state, action: PayloadAction<string>) => {
      state.header.title = action.payload;
    },
    headerSubTitle: (
      state,
      action: PayloadAction<string>,
    ) => {
      state.header.subTitle = action.payload;
    },
  },
  extraReducers: builder => {
    builder.addCase(
      getNotifications.fulfilled,
      (state, action: any) => {
        if (action.payload) {
          state.notifications = {
            data: action.payload,
            status: 'ready',
          };
        }
      },
    );
  },
});

export const selectGeneral = (state: RootState) =>
  state.general;

export const {
  headerTitle,
  headerSubTitle,
} = generalSlice.actions;

export default generalSlice.reducer;
